(function () {
  const slideshow = () => {
    $(".slideshow-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }
      $(this).addClass("slider_started");
      const id = $(this).attr("id");
      const box = $(this).find(".slideshow");
      const autoplay = box.data("autoplay");
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;
      const slideCount = box.data("count");
      const videoAdvance = String(box.data("video-advance")) === "true";
      const loop = slideCount == 1 ? false : true;

      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      } else {
        autoplayParm = {};
      }
      let swiperParms = {
        parallax: true,
        spaceBetween: 0,
        speed: box.data("speed") * 1000,
        loop: loop,
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        },
        ...autoplayParm,
      };
      const swiper = new Swiper(`#${id} .slideshow__swiper`, swiperParms);
      colorScheme(swiper);
      if (videoAdvance) {
        videoAdvanceOnEnd(swiper, autoplay);
      }
      swiper.on("beforeTransitionStart", function () {
        colorScheme(this);
      });
      function colorScheme(context) {
        const activeIndex = context.activeIndex;
        const activeSlide = context.slides[activeIndex];
        const changeItems = [
          context.navigation.nextEl,
          context.navigation.prevEl,
          context.pagination.el,
        ];
        const colorScheme = $(activeSlide)
          .find(".slideshow-slide")
          .data("color-scheme");
        changeItems.forEach((item) => {
          $(item)
            .removeClass("color-background-1")
            .removeClass("color-background-4")
            .addClass(colorScheme);
        });
      }
    });
  };

  /* IFG: con l'opzione attiva, sulle slide video il carosello aspetta la fine
     del video e poi passa alla slide successiva. Il loop del video viene
     disattivato. Se il browser blocca la riproduzione, torna l'autoplay normale. */
  function videoAdvanceOnEnd(swiper, autoplay) {
    const videos = Array.prototype.slice.call(swiper.el.querySelectorAll("video"));
    if (!videos.length) return;
    let fallbackTimer = null;
    let playingVideo = null;

    const activeVideo = () => {
      const slide = swiper.slides[swiper.activeIndex];
      return slide ? slide.querySelector("video") : null;
    };
    const startAutoplay = () => {
      if (autoplay && swiper.autoplay && !swiper.autoplay.running) swiper.autoplay.start();
    };
    const stopAutoplay = () => {
      if (swiper.autoplay && swiper.autoplay.running) swiper.autoplay.stop();
    };

    videos.forEach((video) => {
      video.loop = false;
      video.removeAttribute("loop");
      video.addEventListener("ended", function () {
        if (activeVideo() === video) swiper.slideNext();
      });
    });

    const sync = () => {
      clearTimeout(fallbackTimer);
      const current = activeVideo();
      videos.forEach((video) => {
        if (video !== current) video.pause();
      });
      if (!current) {
        playingVideo = null;
        startAutoplay();
        return;
      }
      stopAutoplay();
      try {
        current.currentTime = 0;
      } catch (e) {}
      playingVideo = current;
      const playing = current.play();
      if (playing && typeof playing.catch === "function") {
        playing.catch(() => {
          if (activeVideo() === current) startAutoplay();
        });
      }
      fallbackTimer = setTimeout(() => {
        if (activeVideo() === current && current.currentTime === 0) startAutoplay();
      }, 4000);
    };

    /* In loop Swiper sposta la slide clonata su quella reale a fine transizione:
       il video prosegue dallo stesso punto invece di ripartire. */
    const handoff = () => {
      const current = activeVideo();
      if (!current || !playingVideo || current === playingVideo) return;
      try {
        current.currentTime = playingVideo.currentTime;
      } catch (e) {}
      playingVideo.pause();
      playingVideo = current;
      current.play().catch(() => startAutoplay());
    };

    swiper.on("slideChange", sync);
    swiper.on("loopFix", handoff);
    swiper.on("slideChangeTransitionEnd", handoff);
    sync();
  }

  document.addEventListener("DOMContentLoaded", function () {
    slideshow();
    document.addEventListener("shopify:section:load", function () {
      slideshow();
    });
  });
})();
